import React from 'react';
import InputLabel, { InputLabelProps } from '@material-ui/core/InputLabel';
import { UdsFC } from '../../types';

export const Label: UdsFC<LabelProps> = ({
  required = false,
  htmlFor,
  disableAnimation = true,
  style,
  children,
  className,
  error,
  dataTest,
  ...rest
}) => (
  <InputLabel
    disableAnimation={disableAnimation}
    required={required}
    error={error}
    className={className}
    htmlFor={htmlFor}
    style={style}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </InputLabel>
);

export interface LabelProps extends InputLabelProps {
  dataTest?: string;
  /* ! please use dataTest instead */
  'data-test'?: undefined;
}
